import React from 'react';

import { ServicePromise } from '../../../services/services';
import { ModalContext } from '../../modal/modal';
import HttpService from '../../../services/http.service';

const DragNDropUploader: React.FC<{ 
  uploadRoute: string, 
  acceptedFileExtensions?: string[], 
  path?: string, 
  onUpload?: (result: Awaited<ServicePromise<string[]>>) => void
  hideInstructions?: boolean
}> = ({uploadRoute, acceptedFileExtensions, path, onUpload, hideInstructions}) => {

  const modalContext = React.useContext(ModalContext);

  const acceptedMediaTest = (name: string): boolean => !!(
    acceptedFileExtensions ?
      acceptedFileExtensions.filter(accepted => name.toLowerCase().endsWith(accepted)).length
    :
      true
  );

  return (
    <div 
      className="flex items-center justify-center w-full h-full mb-4 bg-violet-400"
      onDrop={async (e) => {
        e.preventDefault();
        const files = Array.from(e.dataTransfer.files || []);
        const filteredFiles = files.filter(f => acceptedFileExtensions ? acceptedFileExtensions.some(ext => f.name.toLowerCase().endsWith(ext)) : true);
        if (filteredFiles.length) {
          const uploadRes = await HttpService.upload<string[]>(uploadRoute, filteredFiles, path? { path: path } : {} );
          onUpload?.(uploadRes);
          if (uploadRes.success) {
            modalContext.toast!('success', 'File(s) uploaded successfully.');
          } else {
            modalContext.toast!('warning', 'Error encountered while uploading file(s).');
            console.log(uploadRes.messages);
          }
        }
        if (files.length !== filteredFiles.length) {
          modalContext.toast!('error', `Some files were not uploaded due to unsupported extensions.`); 
        }
      }}
      onDragOver={(e) => {e.preventDefault()}}
    >
      <label htmlFor="dropzone-file" className="flex flex-col items-center justify-center w-full h-full border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600">
        <div className="flex flex-col items-center justify-center pt-5 pb-6">
          <svg className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"/>
          </svg>
          {
            !hideInstructions &&
              <p className="mb-2 text-sm text-gray-500 dark:text-gray-400"><span className="font-semibold">Click to upload</span> or drag and drop</p>
          }
          {
            (acceptedFileExtensions && !hideInstructions) &&
              <div className='text-center'>
                <p className="mb-2 text-xs text-gray-500 dark:text-gray-400">Accepted File Extensions:</p>
                <p className="text-xs text-gray-400 dark:text-gray-400">
                  { acceptedFileExtensions.reduce((a,v) => `${a}, ${v}`, ``).substring(2) }
                </p>
              </div>
          }

        </div>

        <input 
          id="dropzone-file"
          type="file"
          accept='video/*, image/*'
          className='hidden'
          onChange={async e => {
            const files = Array.from(e.target.files || []);
            const filteredFiles = files.filter(f => acceptedFileExtensions ? acceptedFileExtensions.some(ext => f.name.toLowerCase().endsWith(ext)) : true);
            if (filteredFiles.length) {
              const uploadRes = await HttpService.upload<string[]>(uploadRoute, filteredFiles, path? { path: path } : {} );
              onUpload?.(uploadRes);
              if (uploadRes.success) {
                modalContext.toast!('success', 'File(s) uploaded successfully.');
              } else {
                modalContext.toast!('warning', 'Error encountered while uploading file(s).');
                console.log(uploadRes.messages);
              }
            }
            if (files.length !== filteredFiles.length) {
              modalContext.toast!('error', `Some files were not uploaded due to unsupported extensions.`); 
            }
          }}
        />
      </label>
    </div> 
  );
}

export default DragNDropUploader;